import { Plus } from "lucide-react";

export const Marquee = ({ items = [], className = "" }) => {
  const row = [...items, ...items];
  return (
    <div className={`relative overflow-hidden border-y border-white/10 py-6 ${className}`} data-testid="marquee">
      <div className="marquee-track">
        {row.map((it, i) => (
          <span key={i} className="mx-8 inline-flex items-center gap-8 text-[#a7a7a2]">
            <span className="font-mono text-xs tracking-[0.28em] uppercase whitespace-nowrap">{it}</span>
            <Plus size={12} strokeWidth={1.5} className="text-[#5CCBF5]" />
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
